import { cn } from '@/lib/utils';
import { Select } from './Select';

export interface RowsPerPageSelectProps {
  value: number;
  options: readonly number[];
  onChange: (rows: number) => void;
  /**
   * The caption beside the control. `null` drops it where the footer has no
   * room — the field keeps its screen-reader label either way.
   */
  caption?: string | null;
  className?: string;
}

/**
 * How many rows a list shows at once.
 *
 * Every paginated screen in the product needs one, and each had hand-rolled its
 * own bare `<select>` — seven of them, at four different heights, none of them
 * drawn in our own palette. One component instead (CLAUDE.md §3), so the
 * control looks and behaves the same at the bottom of every table.
 *
 * The panel's search box is off: nobody searches four numbers.
 */
export function RowsPerPageSelect({
  value,
  options,
  onChange,
  caption = 'Rows per page',
  className,
}: RowsPerPageSelectProps) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      {caption !== null && <span className="lbl whitespace-nowrap">{caption}</span>}

      <div className="w-[4.75rem] shrink-0">
        <Select
          label="Rows per page"
          hideLabel
          hideSearch
          minPanelWidth={80}
          value={String(value)}
          options={options.map((option) => ({ value: String(option), label: String(option) }))}
          onChange={(event) => onChange(Number(event.target.value))}
          className="h-8 text-xs font-semibold"
        />
      </div>
    </div>
  );
}
